import { render, staticRenderFns } from "./TrashMailDetail.vue?vue&type=template&id=252862da"
import script from "./TrashMailDetail.vue?vue&type=script&lang=js"
export * from "./TrashMailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252862da')) {
      api.createRecord('252862da', component.options)
    } else {
      api.reload('252862da', component.options)
    }
    module.hot.accept("./TrashMailDetail.vue?vue&type=template&id=252862da", function () {
      api.rerender('252862da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/mailbox/TrashMailDetail.vue"
export default component.exports